import wareneingangspruefung from './wareneingangspruefung';

export default {
  wareneingangspruefung,
};
